import requests from '../../../../redux/reducer/requests';
import { useDispatch } from 'react-redux';

export default function useGradesCallbacks() {
  const dispatch = useDispatch();

  return {
    getGrades: () => dispatch(requests.thunks.getGrades()),
  };
}
